var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyesGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 33,
    viewBox: "0 0 90 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_1617_47580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.134 11.3988C83.0007 16.1655 79.0673 21.8488 72.3507 24.0822C65.634 26.3322 58.6673 24.2822 56.784 19.5155C54.9173 14.7488 58.684 12.7822 65.4007 10.5322C72.1173 8.28216 79.2507 6.63217 81.134 11.3988ZM8.86733 11.3988C7.00066 16.1655 10.934 21.8488 17.6507 24.0822C24.3673 26.3322 31.334 24.2822 33.2173 19.5155C35.084 14.7488 31.3173 12.7822 24.6007 10.5322C17.884 8.28216 10.7507 6.63217 8.86733 11.3988Z",
    fill: "#0CC5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_1617_47580",
    x: 0.40332,
    y: 0.326172,
    width: 89.1948,
    height: 32.6699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0458333 0 0 0 0 0.771 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1617_47580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1617_47580",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_1617_47580"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesGlow);
export default __webpack_public_path__ + "static/media/eyes-glow.01b1472cc99655d0ad4f81c8c3b5530b.svg";
export { ForwardRef as ReactComponent };